<p (click)="onClick()" [ngClass]="textClasses">{{ text }}</p>
